import { request } from '../utils';
import store from '../store';

export default function delAdd(root: any, data: any, con, callBack) {
    let ajaxData = {
        addressId: data.addressId,
    };
    request(root, ajaxData).then((rd) => {
        if (rd.errCode == 200) {
            callBack && callBack(true, rd.errDesc);
            if (data.addressId == store.user.addId) {
                store.user.addId = 0;
                store.user.add();
            }
        } else {
            callBack && callBack(false, rd.errDesc);
        }
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/deladd.ts